module.exports = __webpack_public_path__ + "/images/cxa7xH_.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/cn-android-breakout-wechat.png
// module id = 252
// module chunks = 0